import {
  EditProfileRequest,
  GetProfileGalleryImageResponse,
  GetProfileGalleryImagesResponse,
  GetProfileGroupsResponse,
  GetProfilePacksResponse,
  GetProfilesRequest,
  MeResponse,
  NotificationsResponse,
  ProfileResource,
  ProfileRoutes,
  ResourceIDRequest,
  UpdateLocationRequest
} from '@foxbun/lib-goferal-types';
import { ResourceId } from '@journeyapps-labs/micro-codecs';
import { BaseApiClient } from '../base/BaseApiClient';

export class ProfileClient extends BaseApiClient {
  me() {
    return this.post({
      path: ProfileRoutes.ME,
      res: MeResponse
    });
  }

  getProfile(params: ResourceIDRequest) {
    return this.post({
      path: ProfileRoutes.GET_PROFILE,
      req: ResourceId,
      res: ProfileResource,
      params: params,
      buffered: true
    });
  }

  updateLocation(req: UpdateLocationRequest) {
    return this.post({
      path: ProfileRoutes.UPDATE_LOCATION,
      req: UpdateLocationRequest,
      params: req
    });
  }

  getProfiles(req: GetProfilesRequest) {
    return this.paginate({
      path: ProfileRoutes.GET_PROFILES,
      req: GetProfilesRequest,
      codec: ProfileResource,
      params: req
    });
  }

  getProfileGalleryImages(req: ResourceIDRequest) {
    return this.post({
      path: ProfileRoutes.GET_PROFILE_GALLERY_IMAGES,
      req: ResourceId,
      res: GetProfileGalleryImagesResponse,
      params: req
    });
  }

  getProfileGalleryImage(req: ResourceIDRequest) {
    return this.post({
      path: ProfileRoutes.GET_PROFILE_GALLERY_IMAGE,
      req: ResourceId,
      res: GetProfileGalleryImageResponse,
      params: req
    });
  }

  deleteProfileGalleryImage(req: ResourceIDRequest) {
    return this.post({
      path: ProfileRoutes.DELETE_PROFILE_GALLERY_IMAGE,
      req: ResourceId,
      params: req
    });
  }

  editProfile(req: EditProfileRequest) {
    return this.post({
      path: ProfileRoutes.EDIT_PROFILE,
      req: EditProfileRequest,
      params: req
    });
  }

  getProfilePacks(req: ResourceIDRequest) {
    return this.post({
      path: ProfileRoutes.PROFILE_PACKS,
      req: ResourceId,
      res: GetProfilePacksResponse,
      params: req
    });
  }

  getProfileGroups(req: ResourceIDRequest) {
    return this.post({
      path: ProfileRoutes.PROFILE_GROUPS,
      req: ResourceId,
      res: GetProfileGroupsResponse,
      params: req
    });
  }

  notifications() {
    return this.post({
      path: ProfileRoutes.NOTIFICATIONS,
      res: NotificationsResponse
    });
  }
}
